<block-ui>
    <p>{{ message | async }}</p>

</block-ui>

<div style="position: relative"> 
    <!-- It is really important to set loaderId for non-master loader -->
    <ngx-ui-loader [bgsType]="'three-strings'" [loaderId]="'loader-01'"  [fgsType]="'rectangle-bounce-pulse-out'" ></ngx-ui-loader>
  </div>
  